export class InvalidArgumentError extends Error {}

export class LengthError extends Error {}
